var _path, _circle, _path2, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path12, _circle3, _circle4, _circle5, _circle6, _circle7, _path13, _circle8, _circle9, _circle10, _circle11, _circle12, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 130C105.375 130 130 105.423 130 75C130 44.5768 105.375 20 75 20C44.6252 20 20 44.5768 20 75C20 105.423 44.6252 130 75 130Z",
    fill: "#F3F6F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3693,
    cy: 81,
    r: 6,
    fill: "#CCD2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3695 77.5945C10.8302 77.5945 10.4108 78.0539 10.4508 78.5932L10.7503 81.8287C10.7703 82.1483 11.0499 82.4079 11.3695 82.4079C11.6891 82.4079 11.9687 82.1483 11.9886 81.8287L12.2882 78.5932C12.3282 78.0339 11.9088 77.5945 11.3695 77.5945Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3695 83.0071C10.97 83.0071 10.6504 83.3267 10.6504 83.7261C10.6504 84.1256 10.97 84.4451 11.3695 84.4451C11.7689 84.4451 12.0885 84.1256 12.0885 83.7261C12.0885 83.3267 11.7689 83.0071 11.3695 83.0071Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 20,
    r: 6,
    fill: "#E6E9EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121 16.5945C120.461 16.5945 120.042 17.0539 120.081 17.5932L120.381 20.8287C120.401 21.1483 120.681 21.408 121 21.408C121.32 21.408 121.599 21.1483 121.619 20.8287L121.919 17.5932C121.959 17.0339 121.539 16.5945 121 16.5945Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121 22.0071C120.601 22.0071 120.281 22.3267 120.281 22.7261C120.281 23.1256 120.601 23.4451 121 23.4451C121.4 23.4451 121.719 23.1256 121.719 22.7261C121.719 22.3267 121.4 22.0071 121 22.0071Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 30.7297C13.0552 30.7297 12.3205 31.5344 12.3905 32.479L12.9153 38.1466C12.9502 38.7064 13.44 39.1612 13.9998 39.1612C14.5596 39.1612 15.0494 38.7064 15.0844 38.1466L15.6091 32.479C15.6791 31.4994 14.9444 30.7297 13.9998 30.7297Z",
    fill: "#D2D6D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 40.2107C13.3001 40.2107 12.7403 40.7705 12.7403 41.4702C12.7403 42.1699 13.3001 42.7297 13.9998 42.7297C14.6995 42.7297 15.2592 42.1699 15.2592 41.4702C15.2592 40.7705 14.6995 40.2107 13.9998 40.2107Z",
    fill: "#D2D6D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1171 5C65.3299 5 64.7176 5.67056 64.7759 6.45773L65.2133 11.1808C65.2424 11.6472 65.6506 12.0263 66.1171 12.0263C66.5835 12.0263 66.9917 11.6472 67.0208 11.1808L67.4582 6.45773C67.5165 5.6414 66.9042 5 66.1171 5Z",
    fill: "#D2D6D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.117 12.9009C65.5339 12.9009 65.0674 13.3673 65.0674 13.9504C65.0674 14.5335 65.5339 15 66.117 15C66.7001 15 67.1666 14.5335 67.1666 13.9504C67.1666 13.3673 66.7001 12.9009 66.117 12.9009Z",
    fill: "#D2D6D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.924 48.8743C135.665 48.8743 134.685 49.9472 134.778 51.2067L135.478 58.7636C135.525 59.5099 136.178 60.1163 136.924 60.1163C137.67 60.1163 138.323 59.5099 138.37 58.7636L139.07 51.2067C139.163 49.9006 138.184 48.8743 136.924 48.8743Z",
    fill: "#D2D6D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.924 61.5157C135.991 61.5157 135.245 62.2621 135.245 63.195C135.245 64.128 135.991 64.8743 136.924 64.8743C137.857 64.8743 138.603 64.128 138.603 63.195C138.603 62.2621 137.857 61.5157 136.924 61.5157Z",
    fill: "#D2D6D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.75,
    y: 77.6801,
    width: 96,
    height: 16,
    rx: 3,
    transform: "rotate(-2 34.75 77.6801)",
    fill: "url(#paint0_linear_409_2694)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9557,
    y: 83.467,
    width: 26,
    height: 4,
    rx: 1,
    transform: "rotate(-2 40.9557 83.467)",
    fill: "#CACCCE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9344,
    y: 82.2455,
    width: 15,
    height: 4,
    rx: 1,
    transform: "rotate(-2 75.9344 82.2455)",
    fill: "#CACCCE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4845,
    y: 96.4988,
    width: 96,
    height: 16,
    rx: 3,
    transform: "rotate(3 19.4845 96.4988)",
    fill: "url(#paint1_linear_409_2694)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1622,
    y: 102.805,
    width: 30,
    height: 4,
    rx: 1,
    transform: "rotate(3 25.1622 102.805)",
    fill: "#CACCCE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1129,
    y: 104.689,
    width: 24,
    height: 4,
    rx: 1,
    transform: "rotate(3 61.1129 104.689)",
    fill: "#CACCCE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1761,
    y: 38.5354,
    width: 96,
    height: 34,
    rx: 3,
    transform: "rotate(-3 24.1761 38.5354)",
    fill: "url(#paint2_linear_409_2694)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1459 61.482L56.5194 46.1859L74.4369 62.3189L91.1344 43.1072L103.911 45.5991",
    stroke: "#CACCCE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5242,
    cy: 46.2273,
    r: 1.5,
    transform: "rotate(-3 56.5242 46.2273)",
    fill: "white",
    stroke: "#CACCCE",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.4453,
    cy: 62.3184,
    r: 1.5,
    transform: "rotate(-3 74.4453 62.3184)",
    fill: "white",
    stroke: "#CACCCE",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1286,
    cy: 43.1075,
    r: 1.5,
    transform: "rotate(-3 91.1286 43.1075)",
    fill: "white",
    stroke: "#CACCCE",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.911,
    cy: 45.5989,
    r: 1.5,
    transform: "rotate(-3 103.911 45.5989)",
    fill: "white",
    stroke: "#CACCCE",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1464,
    cy: 61.4906,
    r: 1.5,
    transform: "rotate(-3 42.1464 61.4906)",
    fill: "white",
    stroke: "#CACCCE",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6602 52.2149L57.2411 59.9569L73.7706 49.6062L92.0213 60.0311L104.368 54.3256",
    stroke: "#ACAFB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6606,
    cy: 52.2221,
    r: 1.5,
    transform: "rotate(-3 41.6606 52.2221)",
    fill: "white",
    stroke: "#ACAFB2",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.24,
    cy: 59.886,
    r: 1.5,
    transform: "rotate(-3 57.24 59.886)",
    fill: "white",
    stroke: "#ACAFB2",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7792,
    cy: 49.6058,
    r: 1.5,
    transform: "rotate(-3 73.7792 49.6058)",
    fill: "white",
    stroke: "#ACAFB2",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.0155,
    cy: 60.0313,
    r: 1.5,
    transform: "rotate(-3 92.0155 60.0313)",
    fill: "white",
    stroke: "#ACAFB2",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.37,
    cy: 54.3553,
    r: 1.5,
    transform: "rotate(-3 104.37 54.3553)",
    fill: "white",
    stroke: "#ACAFB2",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.608 107.069C131.25 108.584 130.714 110.188 130.088 111.525C128.39 114.822 125.708 117.406 122.4 119.099C119.003 120.792 114.98 121.505 110.958 120.614C101.482 118.654 95.4028 109.386 97.3695 99.9397C99.3362 90.4937 108.544 84.3448 118.02 86.3945C121.417 87.1074 124.367 88.8005 126.87 91.1175C131.071 95.3058 132.859 101.366 131.608 107.069Z",
    fill: "url(#paint3_linear_409_2694)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.099 106.682L116.917 103.5L120.099 100.318C120.736 99.6816 120.806 98.621 120.099 97.9139C119.463 97.2775 118.402 97.2068 117.695 97.9139L114.513 101.096L111.331 97.9139C110.695 97.2775 109.634 97.2068 108.927 97.9139C108.22 98.621 108.22 99.6109 108.927 100.318L112.109 103.5L108.927 106.682C108.291 107.318 108.22 108.379 108.927 109.086C109.563 109.723 110.624 109.793 111.331 109.086L114.513 105.904L117.695 109.086C118.331 109.723 119.392 109.793 120.099 109.086C120.806 108.379 120.736 107.318 120.099 106.682Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_2694",
    x1: 82.75,
    y1: 73.2801,
    x2: 82.75,
    y2: 105.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#DEE2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_409_2694",
    x1: 67.4845,
    y1: 92.0988,
    x2: 67.4845,
    y2: 124.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#DEE2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_409_2694",
    x1: 72.1449,
    y1: 37.749,
    x2: 72.1449,
    y2: 72.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#DEE2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_409_2694",
    x1: 114.62,
    y1: 85.9441,
    x2: 114.62,
    y2: 120.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C5C7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.03a496063d6d0bb291e8409639c7ca62.svg";
export { ForwardRef as ReactComponent };